import React, { forwardRef, useCallback, useMemo } from 'react';
import InputBase from '@mui/material/InputBase';

import useCharacterLimit from '../Input/hooks/useCharacterLimit';
import { TextareaProps } from './types';
import { getTextareaClasses } from './utils';

const Textarea = forwardRef<HTMLTextAreaElement, TextareaProps>((props, ref) => {
  const {
    characterLimit,
    color = 'text-text-paragraph',
    endAdornment: endAdornmentProp,
    inputProps: inputPropsProp,
    onChange: onChangeProp,
    onChangeText,
    value,
    variant = 'body-short-01',
    ...rest
  } = props;

  const { endAdornment, inputProps } = useCharacterLimit({
    characterLimit,
    endAdornment: endAdornmentProp,
    endAdornmentClassName: 'absolute end-20 bottom-8',
    inputProps: inputPropsProp,
    value,
    variant,
  });

  const classes = useMemo(() => getTextareaClasses({ color, variant }), [color, variant]);

  const onChange = useCallback(
    (event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
      onChangeProp?.(event);
      onChangeText?.(event.target.value);
    },
    [onChangeProp, onChangeText],
  );

  return (
    <InputBase
      ref={ref}
      multiline
      classes={classes}
      endAdornment={endAdornment}
      inputProps={inputProps}
      value={value}
      onChange={onChange}
      {...rest}
    />
  );
});

export default Textarea;
